module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-teaching.8ceb73d3.png";